<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Wyślij powiadomienie
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="doctor-send">
                  <v-select
                    v-model="type"
                    :items="typeList"
                    color="blue-grey lighten-2"
                    label="Typ"
                    item-text="label"
                    return-object
                  ></v-select>
                  <v-text-field
                    v-model="title"
                    label="Tytuł"
                    name="title"
                  ></v-text-field>
                  <v-text-field
                    v-model="notification"
                    label="Notyfikacja"
                    name="notification"
                  ></v-text-field>

                  <v-select
                    v-if="type && type.id === 3 && moviesList"
                    v-model="data"
                    :items="moviesList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="id"
                    item-text="title"
                  ></v-select>
                  <v-select
                    v-if="type && type.id === 4 && calendarList"
                    v-model="data"
                    :items="calendarList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="id"
                    item-text="title"
                  ></v-select>
                  <v-select
                    v-if="type && type.id === 5 && reviewsList"
                    v-model="data"
                    :items="reviewsList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="slug"
                    item-text="name"
                  ></v-select>
                  <v-select
                    v-if="type && type.id === 6 && articlesList"
                    v-model="data"
                    :items="articlesList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="id"
                    item-text="title"
                  ></v-select>
                  <v-text-field
                    v-if="type && type.id === 2"
                    v-model="data"
                    label="Url"
                    name="url"
                  ></v-text-field>

                  <v-select
                    v-model="interests"
                    :items="interestsList"
                    color="blue-grey lighten-2"
                    label="Grupa zainterosań"
                    item-value="id"
                    item-text="content"
                    multiple
                  ></v-select>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error darken-1" @click="close()">
            Zamknij
          </v-btn>
          <v-btn color="success darken-1" @click="sendNotify()">
            <v-icon class="mr-4">mdi-email-send-outline</v-icon>
            Wyślij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import axiosConf from "../axios-conf";

export default {
  mixins: [validationMixin],
  name: "DoctorSendNotify",
  props: {
    open: Boolean
  },
  data() {
    return {
      dialog: false,
      typeList: [
        { slug: "webinary", label: "Webinaria", id: 3 },
        { slug: "course", label: "Kurs", id: 3 },
        { slug: "conference", label: "Konferencja", id: 3 },
        { slug: "covid", label: "Covid", id: 3 },
        { slug: "review", label: "Review", id: 5 },
        { slug: "video", label: "Review - Wideo", id: 3 },
        { slug: "review", label: "Review - Artykuł", id: 6 },
        { slug: "calendar", label: "Kalendarium", id: 4 },
        { slug: "url", label: "Url", id: 2 },
        { slug: "notify", label: "Notyfikacja", id: 1 }
      ],
      validUrl: [value => this.isURL(value) || "URL is not valid"],
      moviesList: [],
      reviewsList: [],
      articlesList: [],
      calendarList: [],
      interestsList: [],
      title: "",
      notification: "",
      data: "",
      type: null,
      interests: [],
      errors: {
        title: [],
        notification: [],
        data: [],
        type: [],
        interests: []
      }
    };
  },
  methods: {
    isURL(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    close() {
      this.dialog = false;
      this.$emit("close", "close");
    },
    sendNotify() {
      if(! this.type){
        return;
      }
      axiosConf
        .post(
          "doctor/mobile-push.json",
          {
            title: this.title,
            notification: this.notification,
            data: this.data,
            type: this.type.id,
            interests: this.interests
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          }
        )
        .then(() => {
          this.close();
        });
    },
    setMoviesList(groups) {
      groups.forEach(group => {
        this.moviesList.push({
          header: group.name,
          type: "header"
        });
        group.movies.forEach(movie => {
          this.moviesList.push(movie);
        });
      });
    },
    setArticlesList(groups) {
      groups.forEach(group => {
        this.articlesList.push({
          header: group.name,
          type: "header"
        });
        group.articles.forEach(movie => {
          this.articlesList.push(movie);
        });
      });
    },
    setReviewsList(reviews) {
      reviews.forEach(review => {
        this.reviewsList.push(review);
      });
    },
    setCalendarList(years) {
      years.forEach(year => {
        this.calendarList.push({
          header: year.year,
          type: "header"
        });
        year.items.forEach(item => {
          this.calendarList.push(item);
        });
      });
    }
  },
  mounted() {
    axiosConf
      .get("doctor/interests.json", {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
        }
      })
      .then(response => {
        response.data.interests.forEach(item => {
          this.interestsList.push(item);
        });
      });
  },
  watch: {
    open(newVal) {
      this.interests = [];
      this.interestsList.forEach(item => {
        this.interests.push(item.id);
      });
      this.dialog = newVal;
    },
    type(type) {
      this.data = null;
      this.moviesList = [];
      this.calendarList = [];
      if (type.id === 3) {
        axiosConf
          .get(`/movies/${type.slug}.json`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          })
          .then(response => {
            this.setMoviesList(response.data.groups);
          });
      } else if (type.id === 5) {
        axiosConf
          .get(`/reviews.json`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          })
          .then(response => {
            this.setReviewsList(response.data.reviews);
          });
      } else if (type.id === 6) {
        axiosConf
          .get(`/articles.json`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          })
          .then(response => {
            this.setArticlesList(response.data.groups);
          });
      } else {
        axiosConf
          .get(`/doctor/calendar.json`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          })
          .then(response => {
            this.setCalendarList(response.data.calendar);
          });
      }
    }
  }
};
</script>
